var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThink = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 118 118"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m26.4 92 4.9-4.9 20.2 20.2c4 4 10.4 4 14.4 0L86.3 87l4.9 4.9L71 112.2c-6.7 6.7-17.6 6.7-24.3 0L26.4 92zm32.4-2.4C34.1 89.6 14 69.5 14 44.8 14 20.1 34.1 0 58.8 0c24.7 0 44.8 20.1 44.8 44.8 0 24.7-20.1 44.8-44.8 44.8zm0-82.6C38 7 21 24 21 44.8c0 20.9 17 37.8 37.8 37.8 20.9 0 37.8-17 37.8-37.8C96.6 24 79.7 7 58.8 7z",
  fill: "currentColor"
})));
export default SvgThink;